import type * as React from 'react';
import { intercomContactExists } from '../../../../api/custom/Intercom';
import Link from '../../../components/Link';
import { isFeatureEnabled } from '../../../services/Features';
import { loadIntercom } from '../../../services/Intercom';

const SUPPORT_LINK = 'mailto:help@small-improvements.com';

type Props = {
    children: React.ReactNode;
};

export const openIntercomSupport = async () => {
    const useIntercom = isFeatureEnabled('FEATURE_intercom') && (await intercomContactExists());
    if (useIntercom) {
        const intercom = await loadIntercom();
        intercom('showSpace', 'home');
    } else {
        // Use mail link as fallback.
        window.open(SUPPORT_LINK, '_blank', 'noopener');
    }
};

const onClickIntercomSupportLink: React.MouseEventHandler = async event => {
    event.preventDefault();
    openIntercomSupport();
};

const IntercomSupportLink = ({ children }: Props) => {
    return (
        <Link onClick={onClickIntercomSupportLink} href={SUPPORT_LINK}>
            {children}
        </Link>
    );
};

export default IntercomSupportLink;
